module.exports = __webpack_public_path__ + "media/npc_dota_hero_zuus.5dde38c2.webm";